/**
 * @Description 奥乐齐登录页
 */
import { FC } from 'react';
import { useMethods } from '@lhb/hook';
import { microsoftALQRedirectUrl } from '@/common/api/common';
import styles from './entry.module.less';
import Login from '@/layout/components/Login';

interface ModuleOfALQProps {

};
const ModuleOfALQ: FC<ModuleOfALQProps> = () => {
  const methods = useMethods({
    handleLogin() {
      microsoftALQRedirectUrl().then((res: any) => {
        const { url } = res || {};
        url && (location.href = url);
      });
    },
  });
  return <div className={styles.container}>
    <div
      className={styles.wrapperCon}
      onClick={() => methods.handleLogin()}
    >
      <div className={styles.imgCon}>
        <img
          src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAB/CAMAAAAU0eoIAAAAS1BMVEU5pO/yUCL5uQN/ugH////97cL//PPv9uPy+/7a8fz95d7F5/qn2vhArPH86eTa67385bD4u6/Q5a74qpS/24fzYjz5vBOEvQ+AuwXBFdqPAAAAoklEQVR42u3ONxbCQBBEQQGjlcF77n9StCIgn2ST+nn3qy7ilK9ErQz5locu5ucm3XUl3D67bO8zAgICAgICAgICAgICAgICAgICAgICAgICAgICAkIrQrnnm1fC8Mg3VELzEBD+hHGfb4pa6fOVSpiOXbrDSrhs0716BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBIRWhBjzxa+Sb1l/AVRKrUokqzYFAAAAAElFTkSuQmCC'
          width='100%'
          height='100%'
        />
      </div>
      <div className='c-006 pl-8'>
        ADD登录
      </div>
    </div>
  </div>;
};

interface ALQOfLoginProps {

};
const ALQOfLogin: FC<ALQOfLoginProps> = () => {
  return (
    <Login
      moduleOfALQ={<ModuleOfALQ/>}/>
  );
};

export default ALQOfLogin;
